const fullHeightEls = document.querySelectorAll('.js-full-height');
const headerWrapper = document.querySelector('.js-header-wrapper');
const unboxedBanner = document.querySelector('.js-unboxed-banner');

let calcHeight = height;

// If header exists and large bp, subtract it's height from full height var
if(headerWrapper && width > 1200) {
    calcHeight = height - headerWrapper.offsetHeight;
}

// If unboxedBanner exists, subtract it's height from full height var
if(unboxedBanner) {
    calcHeight = height - unboxedBanner.offsetHeight;
}

function makeFullHeight() {
    fullHeightEls.forEach(el => {
        el.style.height = calcHeight + "px";
    });
}
